/*
* BuildSchemaModel
* Creates a kendo dataSource schema object based on the args.schema name - from the z.Schema
*
*/
export function buildSchemaModel(args) {
    if (!args) {
        return null;
    }

    var defaults = args.defaults || {};
    var readOnly = args.readOnly || [];

    var model: any = {};
    var fields = {};

    model.id = "Id";

    var schema = args.schema;

    if (!schema) {
        model.fields = {
            Id: {
                type: "int"
            }
        };
        return model;
    }

    var names = Object.keys(schema).sort();
    for (var i = 0; i < names.length; i++) {
        var name = names[i];
        var props = schema[name];
        if (props.Type.indexOf("Entity") == -1) {
            var options: any = {};

            var type;
            switch (props.Type) {
                case "datetime":
                    type = "date";
                    break;
                case "boolean":
                case "bool":
                    type = "boolean";
                    break;
                case "int":
                case "number":
                    type = "number";
                    break;
                default:
                    type = "string";
            }

            options.type = type;

            var val: any = {};
            val.required = props.Required || false;
            options.validation = val;

            if (readOnly.indexOf(name) != -1) {
                options.enable = false;
            }

            if (name == "Deleted") {
                options.defaultValue = null;
            } else {
                if (defaults.hasOwnProperty(name)) {
                    options.defaultValue = defaults[name];
                }
            }
            fields[name] = options;
        }

    }
    model.fields = fields;
    return model;
}
